import styled from "@emotion/styled"

export const EventContentEmpty = styled.div<{ $isPast: boolean }>`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;

	/* background-color: ${(props) => (props.$isPast ? "#F6F6F6" : "#fff")}; */
	span {
		&.wheelHousStyle {
			color: #db10c9;
		}
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: 400;
		line-height: 21.6px;
		color: #435363;
	}
	> div {
		width: 100%;
		height: 16px;
		background: linear-gradient(
			90deg,
			rgba(220, 50, 249, 0.23) 0%,
			rgba(255, 243, 254, 0) 129.41%
		);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 8px;
		span {
			height: 10px;
			&:first-of-type {
				width: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				svg {
					width: 100%;
				}
			}
			&:last-child {
				font-weight: 400;
				font-size: 9.33px;
				line-height: 14.4px;
				color: #db10c9;
			}
		}
	}
`
export const EventContentWrapper = styled.div<{
	bookingStatus: "yellow" | "gray" | "green"
	$isActive: boolean
}>`
	background-color: ${(props) =>
		props.bookingStatus === "yellow" && !props.$isActive
			? "#FFF7E1"
			: props.bookingStatus === "gray" && !props.$isActive
				? "#E2E2E2"
				: props.bookingStatus === "green" && !props.$isActive
					? "#D5F7D8"
					: props.$isActive
						? "#5b3fff"
						: "#FFF7E1"};
	border: ${(props) =>
		props.bookingStatus === "yellow" && !props.$isActive
			? "1px solid #FFE9A9"
			: props.bookingStatus === "gray" && !props.$isActive
				? "1px solid #C4C4C4"
				: props.bookingStatus === "green" && !props.$isActive
					? "1px solid #B6E5BB"
					: props.$isActive
						? "1px solid #5b3fff"
						: "1px solid #FFE9A9"};
	border-radius: 34px;
	color: ${(props) => (props.$isActive ? "#fff" : "#435363")};
	.custom-event {
		padding: 6px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 6px;
		.containerIcon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
			svg {
				width: 20px;
				height: 20px;
			}
		}
		.containerContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`

export const DataDisabelWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	background-color: #f6f6f6;
	width: 100%;
	height: 100%;
	flex-direction: column;
	z-index: -1;
	/* &:hover {
		cursor: not-allowed;
	} */
	> div {
		width: 100%;
		height: 100%;
		color: #6b7280;
		font-size: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`
